<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column fitting- -border-radius-1">
      <div class="-header large-">
        <div class="-wrapper-column">
          <p class="-h2 -font-weight-regular">{{ $t('pages_servicerequest.total.chart.header') }}
            <g-tooltip-wrapper
              id="service-request-total-trend-tooltip-wrapper"
            >
              <g-icon name="info" color="gray-1" class="-ml-1"
                id="service-request-total-trend-tooltip-icon"
              ></g-icon>
              <g-tooltip direction="right"
                id="service-request-total-trend-tooltip"
              >
                <span v-html="$t('pages_servicerequest.total.chart.tooltip')" />
              </g-tooltip>
            </g-tooltip-wrapper>
          </p>
        </div>
        <div class="-wrapper">
          <div class="custom-select">
            <g-dropdown
              value="-6"
              @change="onSelected"
              text-class="-mx-0 -pr-0 -pl-2"
            >
              <g-dropdown-item-wrap class="-width-100 -bg-white -box-shadow-level-4"
                id="service-request-total-trend-g-dropdown-item-wrap"
              >
                <g-dropdown-item value="-6" text="Last 7 Days" selected 
                  id="service-request-total-trend-g-dropdown-item-01"
                ></g-dropdown-item>
                <g-dropdown-item value="-14" text="Last 15 Days" 
                  id="service-request-total-trend-g-dropdown-item-02"
                ></g-dropdown-item>
                <g-dropdown-item value="-29" text="Last 30 Days" 
                  id="service-request-total-trend-g-dropdown-item-03"
                ></g-dropdown-item>
              </g-dropdown-item-wrap>
            </g-dropdown>
          </div>
          <div class="-toggle-button -pl-2">
            <div class="-toggle-button">
              <button type="button" name="button" :class="{'selected-': isEqulizer}" @click="onToggleIsLineGraph(false)"
                id="service-request-total-trend-button-01"
              >
                <span class="material-icons">equalizer</span>
              </button>
              <button type="button" name="button" :class="{'selected-': isTimeline}" @click="onToggleIsLineGraph(true)"
                id="service-request-total-trend-button-02"
              >
                <span class="material-icons">timeline</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="-bg-white -wrapper-h-v-center" style="height:300px;">
        <am-xy-chart-2
          id="service-request-total-trend-trend"
          refName="serviceRequestTotalChart"
          :series-type="seriesType"
          :chart-data="chartData"
          :filter="filter"
          :stacked="false"
          numberPrefix=" "
          :useMinGridDistance="useMinGridDistance"
          @hit="onHit"
          :mouse-cursor-style="MOUSE_CURSOR.pointer"
          :useCursorToolTip="true"
        />
      </div>
    </section>
  </div>
</template>

<script>


import AmXyChart2 from '../../components/AmXyChart2'
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP} from "@/constants/constants";
import SpanDropdown from './SpanDropdown'
import {MOUSE_CURSOR} from '@/code/CodeChart'
import moment from 'moment';

am4core.useTheme(am4themes_animated);
export default {
  name: 'servicerequest-total-trend',
  componentName: 'ServiceRequestTotalTrend',
  components: {
    AmXyChart2,
    [SpanDropdown.name]: SpanDropdown
  },
  data () {
    return {
      chartData: [],
      filter: [],
      isLineGraph: false,
      lastDays: -6,
      dateFormat: 'YYYY-MM-DD',
      useMinGridDistance: true,
      MOUSE_CURSOR: MOUSE_CURSOR
    }
  },

  computed : {
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('servicerequest', ['serviceRequestTotalChartData']),

    isEqulizer () {
      return !this.isLineGraph
    },
    isTimeline () {
      return this.isLineGraph
    },
    seriesType () {
      return this.isLineGraph ? 'LineSeries' : 'ColumnSeries'
    }
  },
  methods: {

    ...mapActions('servicerequest', ['getServiceRequestTotalChartData']),
    onHit(ev){
      let date = ev.target._dataItem.dataContext["category"]
      if(!!date){
        date = date.substr(0, 10)
        this.$emit('onClickTrend', date, null);
      }
    },
    onSelected (value) {
      this.lastDays = value
      this.useMinGridDistance = value == -6
      
      this.getData()
    },
    async getData(){
      let param = {
        startDate: moment(new Date().getTime()).add(this.lastDays, 'd').format(this.dateFormat),
        endDate: moment(new Date().getTime()).format(this.dateFormat)
      }
      param.empNo = '';
      param.companyCode = this.userInfo.companyCode
      if (this.userInfo.auth === AUTH_GROUP.BespinSales)  {
        param.empNo = this.userInfo.empNo;
      }else if (this.userInfo.auth === AUTH_GROUP.AccountManager) {
        param.customerDepts = [
          {
            customerCode: this.userInfo.customerCode,
            deptCode: this.userInfo.customerDeptCode
          }
        ]
      }

      await this.getServiceRequestTotalChartData(param)
      this.chartData = this.serviceRequestTotalChartData.chartDatas;
      this.filter = this.serviceRequestTotalChartData.chartFilters;
    },
    onToggleIsLineGraph (isLineGraph) {
      this.isLineGraph = isLineGraph
    }
  },
  created() {

  },
  async beforeMount () {

    await this.getData();

    

  },
}
</script>





// WEBPACK FOOTER //
// src/pages/servicerequest/components/ServiceRequestTotalTrend.vue